import { useCallback, useEffect, useState } from "react";
import BodyInputFormat from "./BodyInputFormat";
import { IFormInputDefault } from "./interfaces";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { addData } from "./utils";

interface IFormSelectSearchProps extends IFormInputDefault{
  options:any[];
  creatable?: boolean;
  onCreate?:(label:string)=>number;
}

export default function FormSelectSearch({
  title,
  name,
  state,
  onChange,
  options,
  onCreate,
  ...props
}:IFormSelectSearchProps){
  const [ optionsList, setOptionsList ] = useState<any[]>([]);

  useEffect(()=>{
    if(options){
      setOptionsList(options.map((item:any)=>{
        if(item.options){
          return { value: item.value, label: item.name, options: item.options.map((item2:any)=>{
            return { value: item2.value, label: item2.name };
          })};
        }
        return { value: item.value, label: item.name };
      }));
    }
  },[options]);

  const getValue = useCallback((value)=>{
    let aux = null;
    optionsList.forEach((item)=>{
      if(item.options){
        item.options.forEach((item2:any)=>{
          if(item2.value.toString() === value.toString()){
            aux = item2;
          }
        });
      } else {
        if(item.value === value){
          aux = item;
        }
      }
    });
    return aux;
  },[optionsList]);
  
  
  let {cleanable, onClear, ...props_aux} = props;
  if(state && name){
    props_aux["name"] = name;
    props_aux["value"] = getValue(state.model?state.model[name]:"");
  } else {
    props_aux["value"] = getValue(props.value);
  }
  

  if(props.creatable){
    return (
      <BodyInputFormat props={{...props_aux,title}}>
        <CreatableSelect
          className="basic-single basic-single-sm"
          classNamePrefix="select"
          isDisabled={props_aux.disabled}
          isLoading={props.isLoading}
          isClearable={cleanable}
          isSearchable={true}
          options={optionsList}
          onChange={(event)=>{
            if(state && name){
              let value = event.value;
              state.setModel((old:any)=>{
                return addData(old,name,value);
              });
            }
            if(onChange)onChange(event)
          }} 
          onCreateOption={async(label)=>{
            if(onCreate){
              let id = await onCreate(label);
              setOptionsList((old:any[])=>{
                return [...old, { label, value:id }]
              })
              if(state && name){
                state.setModel((old:any)=>{
                  return addData(old,name,id);
                });
              }
              if(onChange)onChange({value:id});
            }
          }}
          {...props}
          {...props_aux}
        />
      </BodyInputFormat>
    );
  }

  return (
    <BodyInputFormat props={{...props_aux,title}}>
      <Select
        className="basic-single basic-single-sm"
        classNamePrefix="select"
        isDisabled={props_aux.disabled}
        isLoading={props.isLoading}
        isClearable={cleanable}
        isSearchable={true}
        options={optionsList}
        onChange={(event)=>{
          if(state && name){
            let value = event.value;

            state.setModel((old:any)=>{
              return addData(old,name,value);
            });
          }
          if(onChange)onChange(event)
        }} 
        {...props}
        {...props_aux}
      />
    </BodyInputFormat>
  );
}